module.exports = __webpack_public_path__ + "04_face.94824a6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer1/04_face.png
// module id = E0kp
// module chunks = 0